export function extractIsDevModeFromSearchString(search: string): boolean {
  const parsed = new URLSearchParams(search).get("devMode");
  return parsed ? parsed !== "false" : false;
}
